import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { navigateParaHome } from '../../../../../utils/rotas/navigate'
import { func } from 'prop-types'
import Navegacao from '../components/Navegacao/Navegacao'

import { empty } from '../../../../../utils/helpers/helpers'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import Loader from '@taglivros/oef_componentes/build/components/loader'

import { useGlobal } from '../../../../../contexts/GlobalContext'
import { BOTAO_IR_PARA_HOME } from '../constantsCancelarAssinatura'
import { getFraseModalidade, AGRADECIMENTO, PEDIDO_CONCLUIDO_TITULO, MUDOU_IDEIA_TITULO, DESFAZER_CANCELAMENTO_TEXTO } from './constantsConclusaoCancelamento'

const Content = styled.div`
  margin: 0 0 20px;
  max-width: 65%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }

  h4 {
    margin: 0 0 10px;
    color: ${StyleGuide.cores.cinza500}
    ${StyleGuide.boldFonte}
  }

  p {
    margin: 2px;
  }
`

const LoaderWrapper = styled.div`
  padding: 100px 0;
`

const ConclusaoCancelamento = ( { setToggleDescricao } ) => {
  const [ fraseModalidade, setFraseModalidade ] = useState()
  const { getDadosGlobaisAssociado, modalidadeURL } = useGlobal()

  const finalizarSolicitacao = () => {
    getDadosGlobaisAssociado()
    document.location.reload( true )
    navigateParaHome()
  }

  useEffect( () => {
    if ( empty( fraseModalidade ) ) {
      setFraseModalidade( getFraseModalidade( modalidadeURL ) )
    }

    setToggleDescricao( false )
  }, [] )

  return (
    <div>
      <Card
        className="card"
        largura="100%"
      >
        { fraseModalidade ?
          <Fragment>
            <Content>
              <h4>{ PEDIDO_CONCLUIDO_TITULO }</h4>

              <p>{ fraseModalidade }</p>
            </Content>

            <Content>
              <p>{ AGRADECIMENTO }</p>
            </Content>

            <Content>
              <h4>{ MUDOU_IDEIA_TITULO }</h4>

              <p>{ DESFAZER_CANCELAMENTO_TEXTO }</p>
            </Content>

            <Navegacao
              eventoBotaoContinuar={ finalizarSolicitacao }
              tituloContinuar={ BOTAO_IR_PARA_HOME }
            />
          </Fragment> :
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>}
      </Card>
    </div>
  )
}

ConclusaoCancelamento.propTypes = {
  'setToggleDescricao': func.isRequired
}

export default ConclusaoCancelamento

